import delegateListener from './_delegatelistener/index.js';
import assign from '../_helpers/assign.js';
// creates tree listener
function createTreeListener(_ref) {
  var handler = _ref.handler,
    restPath = _ref.restPath;
  var newHandler = function treeListener(changeEvent) {
    var extendedChangeEvent = assign({
      restPath: restPath
    }, changeEvent);
    // call original handler
    handler.call(this, extendedChangeEvent);
  };
  newHandler._callback = handler;
  // tree listeners of one handler differ by the rest of their path
  newHandler._kind = "tree:" + restPath.join('.');
  return newHandler;
}
// listens changes for all branches of given path
// TODO: Pass context to addTreeListener
// one of the most hard functions to understand
export default function addTreeListener(object, deepPath, handler) {
  if (typeof deepPath === 'string') {
    deepPath = deepPath.split('.');
  }
  // iterate over all keys and delegate listener for all objects of given branch
  for (var i = 0; i < deepPath.length; i++) {
    // TODO: Array.prototype.slice method is slow
    var listenPath = deepPath.slice(0, i);
    var restPath = deepPath.slice(i + 1);
    delegateListener(object, listenPath, "_change:tree:" + deepPath[i], createTreeListener({
      handler: handler,
      restPath: restPath
    }));
  }
}